import React,{useState,useEffect} from 'react';
import {connect} from 'react-redux';
import {logout} from '../store/authActions';
import PasswordChange from './PasswordChange';
import SshKeyUpdate from './SshKeyUpdate';

const AccountActions = ({userid,logout}) => {
  const [action, setAction] = useState('password');

  //only 1500000 < uidNumber < 3000000
  useEffect(()=>{
    const n = Number(userid.uidNumber);
    if(n && (n<1500000 || n>3000000)) logout();
  //eslint-disable-next-line
  },[userid.uidNumber]);

  const onPasswordChange = () => setAction('password');
  const onKeyUpdate = () => setAction('sshkey');
  const onLogout = () => logout();

  return (
    <div className='container'>
      <div className='row' style={{'margin':'20px 50px 20px 50px'}}>
        <label className='col s4'>
          <button className="waves-effect waves-light btn-small" onClick={onPasswordChange}>Change Password</button>
        </label>
        <label className='col s4'>
          <button className="waves-effect waves-light btn-small" onClick={onKeyUpdate}>Update SSH key</button>
        </label>
        <label className='col s2'>
          <button className="waves-effect waves-light deep-orange btn-small" onClick={onLogout}>Logout</button>
        </label>
      </div>

      <div style={{'margin':'50px 0px 50px 0px'}}></div>
      {action==='password' ? <PasswordChange /> : <SshKeyUpdate />}
    </div>
  );
};

const mapStoreToProps = state => ({
  userid: state.auth.userid
});

export default connect(mapStoreToProps,{logout})(AccountActions);
